import { Button, CircularProgress } from '@mui/material';
import React from 'react';

/**
 * Loading button for asynchronous executions
 */
const LoadingButton = (props) => {
  const { position, disabled, isLoading, loadingText, children, ...rest } =
    props;
  return (
    <Button {...rest} disabled={disabled || isLoading}>
      {isLoading ? (
        position === 'right' ? (
          <>
            {`${
              loadingText
                ? loadingText
                : loadingText === false
                  ? ''
                  : 'Chargement...'
            }`}
            <CircularProgress
              color="inherit"
              size="1.5em"
              sx={{ marginLeft: 1 }}
            />
          </>
        ) : (
          <>
            <CircularProgress
              color="inherit"
              size="1.5em"
              sx={{ marginRight: 1 }}
            />
            {`${
              loadingText
                ? loadingText
                : loadingText === false
                  ? ''
                  : 'Chargement...'
            }`}
          </>
        )
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
